import React from 'react';
import { useHitsPerPage } from 'react-instantsearch';
import HitsPerPageControl from './HitsPerPageControl';

type CustomHitsPerPageProps = {
  searchTerm: string | undefined;
};

const HitsPerPage: React.FC<CustomHitsPerPageProps> = ({ searchTerm }) => {
  const { refine, items } = useHitsPerPage({
    items: [
      { value: 36, label: '36', default: true },
      { value: 72, label: '72' },
      { value: 100, label: '100' },
    ],
  });
  const currentValue = Number(items.find(item => item.isRefined)?.value ?? 36);

  return <HitsPerPageControl searchTerm={searchTerm} currentValue={currentValue} onSelect={value => refine(value)} />;
};

const CustomHitsPerPage = HitsPerPage;

export default CustomHitsPerPage;
